import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Utils } from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import EmailCampaignIcon from 'Assets/png/personalised_onboarding/emailCampaign.png';
import TargetAccountsIcon from 'Assets/png/personalised_onboarding/targetAccounts.png';
import SingleContactIcon from 'Assets/png/personalised_onboarding/singleContact.png';
import AdAudienceIcon from 'Assets/png/personalised_onboarding/adAudience.png';
import StarterIcon from 'Assets/png/personalised_onboarding/starter.png';
import { ReactComponent as LeftArrow } from 'Assets/svg/left-arrow.svg';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { userDetail } from 'Stores/userDetail';
import { personalisedOnboardingState } from 'Stores/personalisedOnboardingState';
import { advSearchState } from 'Stores/advSearch';
import { companySearchState } from 'Stores/companySearch';

const {
  PERSONALIED_ONBOARDING_FLOWS,
  MX_PERSONALISED_ONBOARDING_EVENTS,
} = CONSTANTS;
const {
  EMAIL_CAMPAIGN_LIST,
  TARGETED_ACCOUNTS,
  AD_AUDIENCE_LIST,
} = PERSONALIED_ONBOARDING_FLOWS;
const { LB_GOAL_CURRENT_STEP_VALUE } = MX_PERSONALISED_ONBOARDING_EVENTS;
const { START_GOAL } = LB_GOAL_CURRENT_STEP_VALUE;

const USER_GOAL_LIST = [
  {
    name: 'Build Email Campaign List',
    value: 'Email Campaign List',
    imgComponent: EmailCampaignIcon,
    key: 'EMAIL_CAMPAIGN_LIST',
  },
  {
    name: 'Build Target Accounts List',
    value: 'Targeted Accounts',
    imgComponent: TargetAccountsIcon,
    key: 'TARGETED_ACCOUNTS',
  },
  {
    name: 'Find Single Contact',
    value: 'Single Contact Only',
    imgComponent: SingleContactIcon,
    key: 'SINGLE_CONTACT_ONLY',
  },
  {
    name: 'Build Ad Audience List',
    value: 'Ad Audience List',
    imgComponent: AdAudienceIcon,
    key: 'AD_AUDIENCE_LIST',
  },
];

const OnboardingStepsPopup = observer(props => {
  const userGoals = [];
  let optionalGoals = [];

  const { userInfo } = userDetail;
  const { userInterestList = [] } = userInfo;

  if (userInterestList && userInterestList.length > 0)
    // eslint-disable-next-line array-callback-return
    USER_GOAL_LIST.map(item => {
      const { value } = item;

      if (userInterestList.includes(value)) userGoals.push(item);
      else optionalGoals.push(item);
    });
  else optionalGoals = USER_GOAL_LIST;

  const handleOnbStepClick = (e, key) => {
    if (key === EMAIL_CAMPAIGN_LIST) {
      props.history.push('/advanced-search/contact#search');
      advSearchState.clearAllFilters();
    } else if (key === TARGETED_ACCOUNTS || key === AD_AUDIENCE_LIST) {
      props.history.push('/advanced-search/company#search');
      companySearchState.clearAllFilters();
    }
    const eventName = Utils.personalisedOnboardingEventMap(key);
    if (eventName) Utils.mixpanelTrack(eventName, { currentStep: START_GOAL });
    personalisedOnboardingState.setIsPersonalisedOnboardingFlow(key);
    personalisedOnboardingState.setOnboardingCurrentStep(1);
  };

  return (
    <>
      <div className="onboarding-flow-popup">
        <div className="close-icon-wrapper">
          <CloseIcon
            className="close-icon"
            onClick={e => personalisedOnboardingState.clearOnboardingFlow()}
          />
        </div>
        <div className="onboarding-header">
          <div className="title">
            Hey <span className="name">{Utils.getUserName()}</span>, Welcome
            aboard!{' '}
            <span role="img" aria-label="tata">
              🎉
            </span>
          </div>
        </div>
        <div className="onboarding-img-wrapper">
          <img src={StarterIcon} alt="StarterIcon" />
        </div>
        {userGoals.length > 0 && (
          <div className="steps-wrapper your-goals-wrapper">
            <div className="title">Your Goals</div>
            {userGoals.map((item, index) => {
              const { name, imgComponent, key } = item;
              return (
                <div
                  className="step-wrapper"
                  key={`step-${index}`}
                  onClick={e => handleOnbStepClick(e, key)}
                >
                  <img src={imgComponent} alt={name} className="svg-icon" />
                  <div className="step-title">{name}</div>
                  <LeftArrow className="onb-arrow-icon right-arrow" />
                </div>
              );
            })}
          </div>
        )}
        {optionalGoals.length > 0 && (
          <div className="steps-wrapper optional-goals-wrapper">
            <div className="title">Explore more with Adapt </div>
            {optionalGoals.map((item, index) => {
              const { name, imgComponent, key } = item;
              return (
                <div
                  className="step-wrapper"
                  key={`step-${index}`}
                  onClick={e => handleOnbStepClick(e, key)}
                >
                  <img src={imgComponent} alt={name} className="svg-icon" />
                  <div className="step-title">{name}</div>
                  <LeftArrow className="onb-arrow-icon right-arrow" />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
});

export { OnboardingStepsPopup };
export default OnboardingStepsPopup;
